import { useGate, useUnit } from 'effector-react';
import {
  Autocomplete,
  FormControl,
  FormHelperText,
  FormLabel,
  TextField,
  CircularProgress,
} from '@mui/material';
import { Listbox } from '../../../components/listbox';
import { withControl } from '../../../hoc/withControl';
import { ResidentTypesFilterGate, residentTypesFilterQuery } from '../model';
import type { ResidentTypeFilter } from '../types';

type Props = {
  disableClearable?: boolean;
};

export const ResidentTypesFilterControl = withControl<Props>(
  ({
    value,
    setValue,
    error,
    label,
    required,
    readOnly,
    disabled,
    isError,
    disableClearable,
  }) => {
    useGate(ResidentTypesFilterGate);

    const { data, pending } = useUnit(residentTypesFilterQuery);

    return (
      <FormControl required={required} disabled={disabled}>
        {label && <FormLabel error={isError}>{label}</FormLabel>}
        <Autocomplete
          multiple
          disableCloseOnSelect
          loading={pending}
          value={
            !data
              ? []
              : data.filter(
                  (item) =>
                    value
                      .map((i: ResidentTypeFilter) => (typeof i === 'object' ? i.id : i))
                      .indexOf(item.id) > -1
                )
          }
          options={data || []}
          onChange={(_: unknown, newValue: any) => {
            setValue(newValue.map((item: ResidentTypeFilter) => item));
          }}
          ListboxComponent={Listbox}
          renderInput={(params): JSX.Element => (
            <TextField
              {...params}
              InputProps={{
                ...params.InputProps,
                readOnly,
                error: isError,
                endAdornment: readOnly ? null : (
                  <>
                    {pending && <CircularProgress size={20} color="inherit" />}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
          readOnly={readOnly}
          disabled={disabled}
          disableClearable={disableClearable}
        />
        {error && <FormHelperText error>{error}</FormHelperText>}
      </FormControl>
    );
  }
);
